import { Box, Divider, Modal, Stack } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { CustomButton, CustomDropdown, FormModalTitle } from "../../../components";
import SigninTextInput from "../../../components/SigninTextInput";
import i18n from "../../../i18n-config";
import { RootState } from "../../../store/state";
import { capitalizeFirstLetter } from "../../../utils/strings";
import GrouilleurBaraTable from "./GrouilleurBaraTable";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 600, md: 850, lg: 850 },
  backgroundColor: "#ffffff",
  borderRadius: 2,
  height: "80vh",
  overflow: "hidden",
};

interface Props {
  open: boolean;
  onClose(): void;
}

function GrouilleurBaraModal({ open, onClose }: Props) {
  const offres = useSelector((state: RootState) => Object.values(state.offre));
  const categories = useSelector((state: RootState) =>
    Object.values(state.categorie)
  );

  const [formData, setFormData] = useState({
    titre: "",
    idSousCategorie: undefined,
    adresse: "",
  });

  const onChangeField = (key: string, value: string | number) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <form>
        <Box sx={style}>
          <FormModalTitle
            title={i18n.t("rechercher_bara")}
            onClose={handleClose}
            style={{ padding: 3, marginBottom: 0 }}
          />
          <Box sx={{ overflow: "auto", height: "100%", p: 3, pb: 15 }}>
            <Stack
              direction={"row"}
              justifyContent="space-between"
              spacing={2}
              alignItems="flex-end"
              mb={2}
            >
              <SigninTextInput
                title={"Titre"}
                value={formData.titre}
                onChange={(value: string) => onChangeField("titre", value)}
                size="small"
                rootStyle={{ marginTop: 0 }}
              />
              <CustomDropdown
              title={capitalizeFirstLetter(i18n.t("categorie"))}
              value={formData.idSousCategorie}
              items={categories}
              isDynamic
              size="small"
              containerStyle={{ marginTop: 0 }}
              handleChange={(value: string) =>
                onChangeField("idSousCategorie", Number(value))
              }
            />
              <SigninTextInput
                title={"Adresse"}
                value={formData.adresse}
                onChange={(value: string) => onChangeField("adresse", value)}
                size="small"
                rootStyle={{ marginTop: 0 }}
              />
            </Stack>

            <Stack alignItems={"center"}>
              <CustomButton
                title={i18n.t("appliquer_recherche")}
                rootStyle={{ width: 250 }}
              />
            </Stack>
            <Divider sx={{ my: 3 }} />

            <GrouilleurBaraTable data={offres} />
          </Box>
        </Box>
      </form>
    </Modal>
  );
}

export default GrouilleurBaraModal;
